import React, { useMemo } from "react";

import ShyftPassTemplate from "@/components/Templates/ShyftPassTemplate";
import WorkoutScheduleSection from "@/containers/ShyftPassPage/WorkoutScheduleSection";

import { useAppSelector } from "@/hooks";

import mapShyftPassData from "@/containers/ShyftPassPage/mapShyftPassData";
import { ShyftPassDataI } from "@/containers/ShyftPassPage/shyftPassMaps";

import styles from "./ShyftPassSingleClassPage.module.scss";

const ShyftPassSingleClassPage = () => {
  const { data, error } =
    useAppSelector((state) => state.healthProgramV1) || {};

  const { workoutSchedule } = useMemo(() => {
    if (!Object.keys(data)?.length)
      return {
        workoutSchedule: {},
      } as ShyftPassDataI;
    return mapShyftPassData(data);
  }, [data]);

  const workoutScheduleData = {
    ...workoutSchedule,
    title: "Workout schedule",
    description:
      "The exercises are customized to suit individuals with different degrees of physical readiness, ensuring that everyone can participate in and benefit from the workout.",
  };

  return (
    <ShyftPassTemplate error={error}>
      <h1 style={{ display: "none" }}>
        Shyft Pass The Ultimate Health And Wellness Membership
      </h1>
      <div className={styles.shyftPassSingleClassPage}>
        <WorkoutScheduleSection
          {...workoutScheduleData}
          isSingleClassPurchasePage
        />
      </div>
    </ShyftPassTemplate>
  );
};

export default ShyftPassSingleClassPage;
